import { axios } from '@/plugins/axios'

export default class EvaluacionProductividadApiRepository {
  async getById(idPersonal, idEvaluacion) {
    try {
      const { data } = await axios.get(
        `/PoliciaCuadrantes/DesarrolloPolicial/personal/${idPersonal}/productividad/${idEvaluacion}`
      )
      return data
    } catch (error) {
      throw new Error(`Failed to retrieve productividad: ${error.message}`)
    }
  }

  async create(payload) {
    try {
      const { data } = await axios.post(
        `/PoliciaCuadrantes/DesarrolloPolicial/personal/${payload.fk_idPersonalEvaluado}/productividad`,
        payload
      )
      return data.data[0].ID
    } catch (error) {
      throw new Error(`Failed to create productividad: ${error.message}`)
    }
  }

  async update(idPersonal, idEvaluacion, payload) {
    try {
      const { data } = await axios.put(
        `/PoliciaCuadrantes/DesarrolloPolicial/personal/${idPersonal}/productividad/${idEvaluacion}`,
        payload
      )
      return data
    } catch (error) {
      throw new Error(`Failed to update productividad: ${error.message}`)
    }
  }

  async updateStatus(idPersonal, idEvaluacion, payload) {
    try {
      const { data } = await axios.put(
        `/PoliciaCuadrantes/DesarrolloPolicial/personal/${idPersonal}/productividad/${idEvaluacion}`,
        payload
      )
      return data
    } catch (error) {
      throw new Error(`Failed to update status of productividad: ${error.message}`)
    }
  }

  async getEvaluationItems(id) {
    try {
      const { data } = await axios.get(`/PoliciaCuadrantes/DesarrolloPolicial/evaluacion/${id}/indicadorEvaluacion`)
      return data.data
    } catch (error) {
      throw new Error(`Failed to get evaluation items of productividad: ${error.message}`)
    }
  }

  async getActosRelevantes(id) {
    try {
      const { data } = await axios.get(
        `/PoliciaCuadrantes/DesarrolloPolicial/evaluacion/${id}/actosrelevantesEvaluacion`
      )
      return data.data
    } catch (error) {
      throw new Error(`Failed to get evaluation items of productividad: ${error.message}`)
    }
  }

  async getFrecuencias() {
    try {
      const { data } = await axios.get('/PoliciaCuadrantes/DesarrolloPolicial/frecuenciasproductividad')
      return data.data
    } catch (error) {
      throw new Error(`Failed to get evaluation items of productividad: ${error.message}`)
    }
  }
}
